namespace RioERP.Web.Enums {
    export enum SettelementStatusType {
        Unpaid = 1,
        Paid = 2
    }
    Serenity.Decorators.registerEnumType(SettelementStatusType, 'RioERP.Web.Enums.SettelementStatusType');
}
